module.exports = __webpack_public_path__ + "img/logoste.17918baf.png";